import { TrainingPathDto } from "./trainingPathDto";
import { TrainingPathTanslationDto } from "./trainingPathTranslationDto";

export class TrainingPathCreationDTO {
  trainingPathDto: TrainingPathDto;
  trainingPathTranslationDto: TrainingPathTanslationDto[];
}
